'use strict';

var Controller = require('base/Colido.Controller');
var Error404View = require('modules/global/views/layout/error-404');

/**
 * App controller for the shared app
 *
 * @category   Controller
 * @module     share
 * @copyright  Copyright (c) 2016, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@h-m.io>
 */
var AppController = Controller.extend({
    notFound: function(route) {
        var region = App.rootView.mainRegion;

        region.show(new Error404View());
    },

    removeTrailingSlash: function (path) {
        App.router.navigate(path, {trigger: true, replace: true});
    },
});

module.exports = AppController;